import React, { useState } from 'react';

const FilterPanel = ({ brands, measures, onFilter, onSort }) => {
  const [filters, setFilters] = useState({ name: '', brand: '', measure: '' });
  const [sort, setSort] = useState({ field: 'name', direction: 'asc' });

  const handleFilterChange = (field, value) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    onFilter(newFilters);
  };

  const handleSortChange = (field) => {
    const newSort = { ...sort, field };
    setSort(newSort);
    const ordering = field === 'name'
      ? (sort.direction === 'desc' ? `-${field}` : field)
      : (sort.direction === 'desc' ? `-${field}` : field);
    onSort({ ordering });
  };

  const handleSortDirection = (direction) => {
    const newSort = { ...sort, direction };
    setSort(newSort);
    const ordering = direction === 'desc' ? `-${sort.field}` : sort.field;
    onSort({ ordering });
  };

  return (
    <div style={{ backgroundColor: '#f5f5f5', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
      <h3 style={{ marginTop: 0, color: '#3D3D3D' }}>Filters</h3>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '20px' }}>
        <div>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#3D3D3D' }}>
            Name
          </label>
          <input
            type="text"
            placeholder="Search products..."
            value={filters.name}
            onChange={(e) => handleFilterChange('name', e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              boxSizing: 'border-box'
            }}
          />
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#3D3D3D' }}>
            Brand
          </label>
          <select
            value={filters.brand}
            onChange={(e) => handleFilterChange('brand', e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              boxSizing: 'border-box'
            }}
          >
            <option value="">All Brands</option>
            {brands.map((brand) => (
              <option key={brand} value={brand}>
                {brand}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#3D3D3D' }}>
            Measure
          </label>
          <select
            value={filters.measure}
            onChange={(e) => handleFilterChange('measure', e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              boxSizing: 'border-box'
            }}
          >
            <option value="">All Measures</option>
            {measures.map((measure) => (
              <option key={measure.id} value={measure.id}>
                {measure.name} ({measure.abbreviation})
              </option>
            ))}
          </select>
        </div>
      </div>

      <h3 style={{ marginTop: 0, color: '#3D3D3D' }}>Sort</h3>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
        <div>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#3D3D3D' }}>
            Sort By
          </label>
          <select
            value={sort.field}
            onChange={(e) => handleSortChange(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              boxSizing: 'border-box'
            }}
          >
            <option value="name">Name</option>
            <option value="brand">Brand</option>
            <option value="cost">Cost</option>
            <option value="price">Price</option>
          </select>
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#3D3D3D' }}>
            Direction
          </label>
          <div style={{ display: 'flex', gap: '10px' }}>
            <label style={{ flex: 1 }}>
              <input
                type="radio"
                name="direction"
                value="asc"
                checked={sort.direction === 'asc'}
                onChange={() => handleSortDirection('asc')}
                style={{ marginRight: '5px' }}
              />
              Ascending
            </label>
            <label style={{ flex: 1 }}>
              <input
                type="radio"
                name="direction"
                value="desc"
                checked={sort.direction === 'desc'}
                onChange={() => handleSortDirection('desc')}
                style={{ marginRight: '5px' }}
              />
              Descending
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;
